import React from 'react';
import { RichTextRenderer } from '../components/RichTextRenderer';
import { Page } from '../types';

interface PageViewProps {
  page: Page;
}

export const PageView: React.FC<PageViewProps> = ({ page }) => (
  <div className="max-w-4xl mx-auto">
    <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-display font-black mb-16 text-gray-900 leading-none uppercase tracking-tighter">
      {page.title}
    </h1>
    <div className="prose prose-xl max-w-none text-gray-800 text-lg leading-loose">
      {typeof page.content === 'string'
        ? page.content.split('\n').map((line, i) => (
          <p key={i} className="mb-4 font-body">{line}</p>
        ))
        : <RichTextRenderer document={page.content} assets={page.assets} />
      }
    </div>
  </div>
);